import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Flexbox, FlexboxColumn } from '../action/Flexbox';

const AnalysisTableSkeleton = () => {
  const headers = ['Volume', 'Transactions'];
  const baseColor = 'var(--skeleton-base-color)';
  const highlightColor = 'var(--skeleton-highlight-color)';
  return (
    <FlexboxColumn className='analysistable_wrapper' fw gap='0'>
      <Flexbox className='analysistable_wrapper__header' fw justifyContent='flex-start'>
        <Flexbox className='analysistable_wrapper__stats' justifyContent='flex-start'>
          <Skeleton width={100} height={20} baseColor={baseColor} highlightColor={highlightColor} />
        </Flexbox>
        <Flexbox className='analysistable_wrapper__data'>
          {headers.map(item => (
            <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row' key={item}>
              <Skeleton width={100} height={20} baseColor={baseColor} highlightColor={highlightColor} />
              {/* <ThemeLogo icon={'sort'} /> */}
            </Flexbox>
          ))}
        </Flexbox>
        <Flexbox className='analysistable_wrapper__action'></Flexbox>
      </Flexbox>

      <Flexbox className='analysistable_wrapper__row' fw>
        <Flexbox className='analysistable_wrapper__stats' justifyContent='flex-start'>
          <Skeleton width={100} height={20} baseColor={baseColor} highlightColor={highlightColor} />
        </Flexbox>
        <Flexbox className='analysistable_wrapper__data'>
          {headers.map(item => (
            <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row' key={item}>
              <Skeleton width={100} height={20} baseColor={baseColor} highlightColor={highlightColor} />
              {/* <ThemeLogo icon={'sort'} /> */}
            </Flexbox>
          ))}
        </Flexbox>
        <Flexbox className='analysistable_wrapper__action'></Flexbox>
      </Flexbox>
    </FlexboxColumn>
  );
};

export default AnalysisTableSkeleton;
